//react
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { MdArrowDropDown, MdArrowDropUp, MdArrowLeft } from "react-icons/md";

//images
import domLogo from "../../components/images/domThumb.png";
import domRedesign from "../../components/images/dom/dom-redesign.png";
import domExample from "../../components/images/dom/dom-example.png";
import domFlow from "../../components/images/dom/dom-flow.png";
import domGreen from "../../components/images/dom/dom-green.png";
import domGreenBanner from "../../components/images/dom/dom-green-banner.png";
import domColours from "../../components/images/dom/dom-colours.png";

//other
import "../ProjectsTitle.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export const DomTitle = () => {
  let isIntroDone = false;

  let anim = gsap.timeline();
  let animDistance = "-10vh";
  let animDuration = 0.5;
  let animTrans = "transparent";
  let animColour = "#fff";

  //intro animations
  useEffect(() => {
    anim
      .fromTo(
        ".projects-intro",
        { y: "-25%", opacity: 0 },
        {
          y: 0,
          duration: animDuration,
          opacity: 1,
        }
      )
      .to(
        ".projects-intro",
        {
          y: "25%",
          duration: animDuration,
          opacity: 0,
        },
        "+=0.2"
      )
      .fromTo(
        ".projects-header-container",
        { y: animDistance, opacity: 0 },
        {
          y: 0,
          duration: animDuration,
          opacity: 1,
        }
      )
      .fromTo(
        ".projects-text",
        { y: animDistance, color: animTrans },
        {
          y: 0,
          duration: animDuration,
          color: animColour,
        },
        "-=0.3"
      )
      .fromTo(
        ".projects-image",
        { opacity: 0, y: "-10%" },
        {
          opacity: 1,
          y: "0",
          stagger: 0.1,
        },
        "-=0.5"
      )
      .fromTo(
        ".projects-scroll-button",
        { opacity: 0, y: "-50%" },
        {
          opacity: 1,
          y: "0",
          stagger: 0.1,
        }
      );

    isIntroDone = true;
  }, [isIntroDone === false]);

  const ScrollDown = () => {
    const scroller = document.querySelector(".scrollable-projects");
    scroller.scrollBy(0, 200);
  };

  const ScrollUp = () => {
    const scroller = document.querySelector(".scrollable-projects");
    scroller.scrollBy(0, -200);
  };

  return (
    <>
      <div className="scrollable-projects">
        <div className="projects-intro">
          <img
            src={domLogo}
            alt="intro"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div className="projects-header-container">
          <div className="projects-title">
            <p>
              FREEDOM <br /> GAMING
            </p>
          </div>
          <Link className="projects-back" to="/designer">
            <MdArrowLeft />
          </Link>
        </div>
        <div className="projects-text">
          <p>
            Dom runs a YouTube channel of about 26,000 subscribers, he wanted
            his logo and channel art cleaning up, below you can see the image I
            was working from as well as the finished result. He wanted a moody
            street vibe to it but I also provided him an alternative colourway
            he could use if he so desired.
          </p>
        </div>
        <div className="projects-section">
          <div className="projects-image image-span">
            <img
              src={domRedesign}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="projects-image image-span">
            <img
              src={domExample}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="projects-image">
            <img
              src={domFlow}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="projects-image">
            <img
              src={domGreen}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="projects-image image-span">
            <img
              src={domGreenBanner}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="projects-image image-span">
            <img
              src={domColours}
              alt="image"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      </div>
      <div className="projects-buttons-container">
        <button className="projects-scroll-button" onClick={() => ScrollUp()}>
          <MdArrowDropUp />
        </button>
        <button className="projects-scroll-button" onClick={() => ScrollDown()}>
          <MdArrowDropDown />
        </button>
      </div>
    </>
  );
};

export default DomTitle;
